import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
              深度解析
            </h4>
            <p className="text-sm leading-relaxed text-background-400">
              以学术视角深度剖析都市文化现象，提供客观、全面、有深度的情感与社会议题分析。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/xianxiang-jiexi" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  现象解析
                </Link>
              </li>
              <li>
                <Link to="/category/xinli-fenxi" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  心理分析
                </Link>
              </li>
              <li>
                <Link to="/category/shehui-yingxiang" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  社会影响
                </Link>
              </li>
              <li>
                <Link to="/category/hunyin-baohu" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  婚姻保护
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/renqi-lieren-qiyuan-jiexi" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  人妻猎人的起源
                </Link>
              </li>
              <li>
                <Link to="/article/lieyan-zhe-xinli-dongji" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  猎艳者心理画像
                </Link>
              </li>
              <li>
                <Link to="/article/hunyin-weiji-yufang-zhinan" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  婚姻危机预防指南
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  品牌故事
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 深度解析. 保留所有权利。本站内容仅供信息参考，不构成专业建议。
          </p>
          <div className="flex items-center space-x-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;